export default __webpack_public_path__ + "static/media/html-icon.b94fd435.svg";